export const allPastelColors = [
  "#F9DCC4",
  "#CAFFBF",
  "#B1E6F3",
  "#F6D6D6",
  "#E6CBF7",
  "#A8C3BC",
  "#D7E4C0",
  "#D0E6A5",
  "#EDD4E8",
  "#FFADAD",
  "#A1ECFF",
  "#B0A8F6",
  "#FFE0B5",
  "#B9FFAF",
  "#CBC7F8",
  "#D8B5BE",
  "#E2E7BD",
  "#D8BBFF",
  "#FDC5F5",
  "#ACF2C9",
  "#B795E4",
  "#EBDEBE",
  "#F2B0B0",
  "#95DFF2",
  "#E6E6FA",
  "#B8C19C",
  "#F3CFCE",
  "#9FAFFF",
  "#FCD1F5",
  "#8AF0BF",
  "#D4E2D4",
  "#C9D6EA",
  "#E4D0EC",
  "#DADADA",
  "#F5E1E1",
  "#E2CEDB",
  "#D2E0FB",
  "#CAD2C5",
  "#D0CDE1",
  "#E8D5C4",
  "#E7D5D5",
  "#F7F5ED",
  "#E1F2FB",
  "#97A5EE",
  "#B3E1F8",
];
